export interface CreateTenantRequest {
  name: string;
  environmentId: string;
  archiveId: number;
  hdmApiEndpoint: string;
  operations: TenantOperation[];
  hdmCredentials: HdmCredential;
}

export interface UpdateTenantRequest {
  hdmApiEndpoint: string;
  operations: TenantOperation[];
  hdmCredentials?: HdmCredential;
}

export interface Tenant {
  tenantId: string;
  name: string;
  environmentId: string;
  archiveId: number;
  hdmApiEndpoint: string;
  operations: TenantOperation[];
  clientId: string;
}

export enum TenantOperation {
  onDemand = "onDemand",
  onBoarding = "onBoarding",
  archive = "archive",
  searchFilterBuilder = "searchFilterBuilder",
}

export interface HdmCredential {
  username: string;
  password: string;
}
